import { render, staticRenderFns } from "./co2concentration.vue?vue&type=template&id=389d888c"
import script from "./co2concentration.vue?vue&type=script&lang=js"
export * from "./co2concentration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports